import { isUndefined, omitBy } from "lodash-es";

import { MapFilterModel } from "@mapmycustomers/shared/types/viewModel/internalModel/MapFilterModel";

import { cleanUpFilterModel as standardCleanUpFilterModel } from "./cleanUpFilterModel";
import { FILTER_ENTITY_TYPES } from "./consts";

export const cleanUpMapFilterModel = (
  filters: MapFilterModel,
  removeUndefined?: boolean
): MapFilterModel => {
  const result = FILTER_ENTITY_TYPES.reduce(
    (result, entityType) => ({
      ...result,
      [entityType]: result[entityType]?.conditions.length
        ? standardCleanUpFilterModel(result[entityType]!)
        : undefined,
    }),
    filters
  );
  return removeUndefined ? omitBy(result, isUndefined) : result;
};
